<template>
  <b-modal id="modal-pdf-viewer" v-model="vis" size="lg" centered scrollable header-bg-variant="secondary"
    header-text-variant="light" footer-class="justify-content-between" @hidden="$emit('fecharModal')">
    <template v-slot:modal-header="controls">
      <h5>{{ modalTitle }}</h5>
      <div>
        <b-button size="sm" title="Página anterior" :disabled="page == 1" @click="page--" class="mx-1"
          variant="secondary">
          <font-awesome-icon icon="chevron-left" />
        </b-button>
        <span class="mx-1 d-none d-sm-inline">{{ textoPaginacao }}</span>
        <span class="mx-1 d-sm-none">{{ textoPaginacaoMobile }}</span>
        <b-button size="sm" title="Próxima página" :disabled="page == numPages" @click="page++" class="mx-1"
          variant="secondary">
          <font-awesome-icon icon="chevron-right" />
        </b-button>
        <b-btn @click="controls.close">
          <font-awesome-icon icon="times" />
        </b-btn>
      </div>
    </template>
    <div>
      <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center"
        :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>
      <VuePdfEmbed
        ref="pdf"
        :source="pdfData"
        :page-number="page"
        @rendered="onRendered"
        @loaded="onLoaded"
      />
    </div>
    <template v-slot:modal-footer>
      <b-button size="sm" title="Fazer download" @click="downloadPdf()" class="mx-1 text-left" variant="secondary">
        <font-awesome-icon icon="file-download" />
        <span class="d-none d-sm-inline ml-2">Download</span>
      </b-button>
      <div v-if="dadosLogObrigatorio && dadosLogObrigatorio.IdLogVisualizacao">
        <b-button v-if="!confirmacaoLeitura" variant="success" @click="ConfirmarVisualizacaoRelatorio"
          :disabled="loadingConfirmacao">
          <b-spinner small v-if="loadingConfirmacao" class="mr-2"></b-spinner>
          <font-awesome-icon v-else icon="check" />
          Declaro que visualizei este relatório
        </b-button>
        <span v-else>{{ confirmacaoLeitura }}</span>
      </div>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import pcmService from "@/services/entregas/pcmService"
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { PropType } from "vue";
import { UtilsTS } from "@/utilsts"
import { RelatorioObrigatorio } from '@/types/relatorios/relatorio-obrigatorio'

const CompProps = Vue.extend({
  name: 'ModalPDF',
  components: { VuePdfEmbed },
  props: {
    titulo: {
      type: String,
      required: false
    },
    pdfData: {
      required: true
    },
    filename: {
      type: String,
      required: true
    },
    dadosLogObrigatorio: {
      type: Object as PropType<RelatorioObrigatorio>,
      required: false
    }
  },
})

@Component
export default class ModalPdf extends mixins(UtilsTS, CompProps) {
  vis = true

  //estes vêm do pdf-viewer
  loadedRatio = 0
  page = 1
  numPages = 0
  rotate = 0

  //referente a relatórios obrigatórios
  loadingConfirmacao = false
  confirmacaoLeitura = ''


  get modalTitle(): string {
    return this.titulo ?? 'Ver PDF'
  }

  get textoPaginacao(): string {
    return `Página ${this.page} de ${this.numPages}`
  }
  get textoPaginacaoMobile(): string {
    return `${this.page} de ${this.numPages}`
  }


  downloadPdf(): void {
    const timestamp = this.montarTimestamp()

    if (this.pdfData instanceof Uint8Array) {
      const blob: Blob = new Blob([this.pdfData], { type: 'application/pdf' });
      this.download(`${this.filename}_${timestamp}.pdf`, blob);
    } else {
      this.downloadFromUrl(`${this.filename}_${timestamp}.pdf`, this.pdfData);
    }

  }
  montarTimestamp(): string {
    const agora = new Date();
    return `${agora.getDate().toString().padStart(2, '0')}${(agora.getMonth() + 1).toString().padStart(2, '0')}${agora.getFullYear()}_${agora.getHours().toString().padStart(2, '0')}${agora.getMinutes().toString().padStart(2, '0')}${agora.getSeconds().toString().padStart(2, '0')}`
  }

  async ConfirmarVisualizacaoRelatorio(): Promise<void> {
    try {
      this.loadingConfirmacao = true
      //await new Promise(r => setTimeout(r, 2000));
      const response = await pcmService.confirmarVisualizacaoRelatorioObrigatorio(this.dadosLogObrigatorio.IdLogVisualizacao)
      this.confirmacaoLeitura = response.getConfirmacaoLeitura()
      this.$emit('confirmarVisualizacao')
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      this.loadingConfirmacao = false
    }
  }
  // vue-pdf-embed events
  onLoaded(pdf): void {
    this.numPages = pdf.numPages
    this.loadedRatio = 1
  }

  onRendered(): void {
    // Optionally handle after page render
  }

  created(): void {
    if (this.dadosLogObrigatorio && this.dadosLogObrigatorio.logs && this.dadosLogObrigatorio.logs.length) {
      const logConfirmacao = this.dadosLogObrigatorio.logs.find(lo => lo.DataConfirmacao !== null)
      if (logConfirmacao) this.confirmacaoLeitura = logConfirmacao.getConfirmacaoLeitura()
    } 
  }
}
</script>
